module.exports = __webpack_public_path__ + "static/media/Slightly.5efd742b.ogg";